angular.module('app')
    .component('verdictChip', {
        template: function() {
            var template = [
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="chart" ng-attr-width="{{$ctrl.width}}" ng-attr-height="{{$ctrl.height}}">',                
                '<rect class="bar untested" ng-attr-width="{{$ctrl.untestedWidth}}" ng-attr-height="{{$ctrl.height}}" ng-attr-x="{{$ctrl.untestedX}}" y="0"></rect>',
                '<rect class="bar fail" ng-attr-width="{{$ctrl.failedWidth}}" ng-attr-height="{{$ctrl.height}}" ng-attr-x="{{$ctrl.failedX}}" y="0"></rect>',
                '<rect class="bar pass" ng-attr-width="{{$ctrl.passedWidth}}" ng-attr-height="{{$ctrl.height}}" ng-attr-x="{{$ctrl.passedX}}" y="0"></rect>',
                '<text x="6" y="16" font-family="Verdana" font-size="13">{{$ctrl.text}}</text>',                
                '</svg>'
            ].join('');
            return template;
        },
        bindings: { passed: '<', failed: '<', untested: '<', height: '<', width: '<', text: '<' },
        controller: function() {
            if (angular.isUndefined(this.height)) { this.height = 10; }

            // Using percentages of width
            var passed = this.passed;
            var failed = this.failed;
            var untested = this.untested;
            var total = this.passed + this.failed + this.untested;

            // Get percentages
            var untestedPct = 100 * untested / total;
            var failedPct = 100 * failed / total;
            var passedPct = 100 * passed / total;

            // Normalise the chip widths to the total width
            var width = this.width;
            this.passedWidth = width * passedPct / 100;
            this.untestedWidth = width * untestedPct / 100;
            this.failedWidth = width * failedPct / 100;

            // Layout the chips by y offset
            this.failedX = 0;
            this.passedX = this.failedWidth;
            this.untestedX = this.failedWidth + this.passedWidth;
           
        }
    });
